import getDimensions from './getDimensions';
import getCursorPosition from './getCursorPosition';

const getBackgroundPosition = (e, zoomedImg) => {
    let coordinates = {
        x: 0,
        y: 0,
    };

    if (!zoomedImg) return coordinates;

    const { imageWidth, imageHeight, lensWidth, lensHeight, rx, ry } = getDimensions(zoomedImg);
    const pos = getCursorPosition(e, zoomedImg);

    // calculate lens position
    let x = pos.x - lensWidth / 2;
    let y = pos.y - lensHeight / 2;

    // prevents lens to overflow image position
    if (x > imageWidth - lensWidth) {
        x = imageWidth - lensWidth;
    }
    if (x < 0) {
        x = 0;
    }
    if (y > imageHeight - lensHeight) {
        y = imageHeight - lensHeight;
    }
    if (y < 0) {
        y = 0;
    }

    coordinates = {
        ...coordinates,
        x: x === 0 ? 0 : x * rx * -1,
        y: y === 0 ? 0 : y * ry * -1,
    };

    return coordinates;
};

export default getBackgroundPosition;
